import { DashboardWidget } from '../../Dashboard/DashboardWidget/DashboardWidget';

const def: DashboardWidgetDefinition = {
    id: 'off_balance',
    title: 'Off Balance',
    type: 'growthAllocation',
    queryMeta: {
        dataVariant: 'preTrade',
    },
    filters: [
        {
            id: 'activeWeight',
            value: {
                gt: 0.1,
                lt: -0.1,
                mode: 'OR',
            },
        },
    ],
    columnIds: [
        'tradeDate',
        'pId',
        'portfolioGuid',
        'householdName',
        'referencePortfolio',
        'allocationType',
        'currentExposure',
        'targetExposure',
        'activeExposure',
        'exposureStatus',
        'currentWeight',
        'targetWeight',
        'activeWeight',
        'targetGrowthSleeve',
        'actualUnencumberedCash',
        'reportStage',
    ],
};

export const OffBalance = () => <DashboardWidget widgetDefinition={def} />;
